import { useProductContext } from "../context"

export const ProductSeriesName = () => {
  const { seriesName } = useProductContext()

  if (!seriesName) {
    return null
  }

  return <div>{seriesName}</div>
}
